import { SearchResult } from "@/types/client-search";

interface SearchResultsProps {
  results: SearchResult[];
  onSelect: (profile: SearchResult) => void;
}

export const SearchResults = ({ results, onSelect }: SearchResultsProps) => {
  if (results.length === 0) return null;

  return (
    <div className="absolute z-10 w-full mt-1 bg-white rounded-md shadow-lg">
      <ul className="py-1">
        {results.map((profile) => (
          <li
            key={profile.id}
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
            onClick={() => onSelect(profile)}
          >
            {profile.first_name} {profile.last_name}
            {profile.email && (
              <span className="text-sm text-gray-500 ml-2">({profile.email})</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};